/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  ExceptionResponse,
  ResendNotificationRequest,
  ResendNotificationResult,
  ResendOptions,
  ValidationProblemDetails,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse200 =
  {
    data: ResendOptions;
    status: 200;
  };

export type getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse401 =
  {
    data: void;
    status: 401;
  };

export type getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse403 =
  {
    data: void;
    status: 403;
  };

export type getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse404 =
  {
    data: ExceptionResponse;
    status: 404;
  };

export type getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse422 =
  {
    data: ExceptionResponse;
    status: 422;
  };

export type getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseSuccess =
  getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse200 & {
    headers: Headers;
  };
export type getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseError =
  (
    | getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse401
    | getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse403
    | getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse404
    | getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse422
  ) & {
    headers: Headers;
  };

export const getGetApiCcofPracticeIdPatientsPatientIdNotificationsResendUrl = (
  practiceId: string,
  patientId: string,
) => {
  return `/api/ccof/${practiceId}/patients/${patientId}/notifications/resend`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary What a manual resend would send for the patient and where it would go: the latest statement, the
notification that would be repeated, and the active guarantor's phone and email with per-channel
availability. Drives the Send dropdown and the confirmation popup.
 */
export const getApiCcofPracticeIdPatientsPatientIdNotificationsResend = async (
  practiceId: string,
  patientId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseSuccess> => {
  return authenticatedClient<getApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseSuccess>(
    getGetApiCcofPracticeIdPatientsPatientIdNotificationsResendUrl(
      practiceId,
      patientId,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse200 =
  {
    data: ResendNotificationResult;
    status: 200;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse400 =
  {
    data: ValidationProblemDetails;
    status: 400;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse401 =
  {
    data: void;
    status: 401;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse403 =
  {
    data: void;
    status: 403;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse404 =
  {
    data: ExceptionResponse;
    status: 404;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse409 =
  {
    data: ExceptionResponse;
    status: 409;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse422 =
  {
    data: ExceptionResponse;
    status: 422;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse429 =
  {
    data: ExceptionResponse;
    status: 429;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse502 =
  {
    data: ExceptionResponse;
    status: 502;
  };

export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseSuccess =
  postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseError =
  (
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse400
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse401
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse403
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse404
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse409
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse422
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse429
    | postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponse502
  ) & {
    headers: Headers;
  };

export const getPostApiCcofPracticeIdPatientsPatientIdNotificationsResendUrl = (
  practiceId: string,
  patientId: string,
) => {
  return `/api/ccof/${practiceId}/patients/${patientId}/notifications/resend`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Resends the latest notification of the patient's latest statement on the chosen channel — the same message the
guarantor last received, rebuilt with today's amounts and a fresh pay link. The body echoes what the popup
showed; a resend is refused (409) when the statement, the notification or the recipient changed since.
 */
export const postApiCcofPracticeIdPatientsPatientIdNotificationsResend = async (
  practiceId: string,
  patientId: string,
  resendNotificationRequest?: ResendNotificationRequest,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return authenticatedClient<postApiCcofPracticeIdPatientsPatientIdNotificationsResendResponseSuccess>(
    getPostApiCcofPracticeIdPatientsPatientIdNotificationsResendUrl(
      practiceId,
      patientId,
    ),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(resendNotificationRequest),
    },
  );
};
